import Store from '../store';

export async function can(rightsGroup, subjects, otherConditions) {
  const allSubjects = !_.isArray(subjects) ? [subjects] : subjects;
  const rightsToCheck = _.map(allSubjects, subject => `${rightsGroup}.${subject}`);
  const hasRight = await Store.dispatch('auth/hasRights', rightsToCheck);
  return _.isEmpty(rightsGroup) || (_.every(otherConditions, c => c === true) && hasRight);
}

export default {};
